export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fCxc4EsA.woff2";